module.exports = __webpack_public_path__ + "f5a5a45e22126a26ab85604f1b27b239.svg";